<app-web-console-container *ngIf="webConsoleConfig" [workItem]="workItem" [webConsoleConfig]="webConsoleConfig"></app-web-console-container>
